import axios from 'axios';
import { redirectPermission, getAccessToken, getTenantId } from '../helper';

const localTest = axios.create({
    baseURL: 'http://localhost:4002/api/v1',
});

localTest.interceptors.request.use(
    function (config) {
        config.headers.Authorization = `Bearer ${getAccessToken}`;
        const tenantId = getTenantId();
        if (tenantId && tenantId !== 'undefined' && tenantId !== 'null') {
            config.headers['x-tenant-id'] = tenantId;
        } else {
            delete config.headers['x-tenant-id']; // ensure it's not passed at all
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

localTest.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if (error.response && error.response.status === 401) {
            redirectPermission();
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default localTest;
